import { environment } from '../../environments/environment';
import { Configuration, ConfigurationParameters } from '../api';

export class ApiConfiguration extends Configuration {
  constructor(params?: Partial<ConfigurationParameters>) {
    super({
      basePath: environment.api.base,
      withCredentials: true,
      ...params,
    });
  }
}
